module.exports = __webpack_public_path__ + "static/media/home-text-behind-transparent.85caffcd.png";